import React, { useEffect, useRef, useState } from "react";
import { CardContent } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../LoadingSpinner";
import {
  useGetAllUserListQuery,
  useGetAgentPerformanceReportQuery,
} from "../../../../Services/reports/tickets/ReportTickets";
import { toast } from "react-toastify";
import CsvDownloader from "react-csv-downloader";

const AgentPerformanceReport1 = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [reportType, setReportType] = useState("Inbound"); // Default to Inbound
  const [dateFrom, setDateFrom] = useState<string>("");
  const [dateTo, setDateTo] = useState<string>("");
  const [selectedAssignee, setSelectedAssignee] = useState<string>("");
  const [theUser, setTheUser] = useState<any>([]);
  const { data: userData, isLoading: userLoading } = useGetAllUserListQuery({});
  const [params, setParams] = useState<any>(null);
  const [dataRows, setDataRows] = useState<any[]>([]);
  const [localLoading, setLocalLoading] = useState(false);

  const {
    data: agentPerformanceData,
    isLoading: agentPerformanceLoading,
    status: agentPerformanceStatus,
  } = useGetAgentPerformanceReportQuery(params, {
    skip: !params,
  });

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });
  const columnsInbound: GridColDef[] = [
    {
      field: "srNo",
      headerName: "Sr.no",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "agentName",
      headerName: "Agent name",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalLoginTime",
      headerName: "Total login time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalInboundCalls",
      headerName: "Total calls offer",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalTalkTime",
      headerName: "Total talk time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "avgTalkTime",
      headerName: "Avg talk time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalHoldTime",
      headerName: "Total hold time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "avgHoldTime",
      headerName: "Avg hold time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalAcw",
      headerName: "Total ACW",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "avgAcw",
      headerName: "Avg ACW",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalHandleTime",
      headerName: "Total handle time",
      flex: 1,
      minWidth: 150,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "avgHandleTime",
      headerName: "Avg handle time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },

    // {
    //   field: "totalCallsHandled",
    //   headerName: "Total Calls Handled",
    //   flex: 1,
    //   align: "center",
    //   headerAlign: "center",
    // },

    {
      field: "totalInboundIdealTime",
      headerName: "Total ideal time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "totaloutboundauxTime",
      headerName: "Total outbound aux",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "totalBreakTime",
      headerName: "Total break time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "occupancy",
      headerName: "Occupancy",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
  ];

  const columnsOutbound: GridColDef[] = [
    {
      field: "srNo",
      headerName: "Sr.no",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "agentName",
      headerName: "Agent name",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalLoginTime",
      headerName: "Total login time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalOutboundCalls",
      headerName: "Total calls",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalTalkTime",
      headerName: "Total talk time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "avgTalkTime",
      headerName: "Avg talk time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalHoldTime",
      headerName: "Total hold time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "avgHoldTime",
      headerName: "Avg hold time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalAcw",
      headerName: "Total ACW",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "avgAcw",
      headerName: "Avg ACW",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalHandleTime",
      headerName: "Total handle time",
      flex: 1,
      minWidth: 150,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "avgHandleTime",
      headerName: "Avg handle time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },

    // {
    //   field: "totalCallsHandled",
    //   headerName: "Total Calls Handled",
    //   flex: 1,
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      field: "totalOutboundIdealTime",
      headerName: "Total ideal time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalManualTime",
      headerName: "Total inbound aux",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "totalBreakTime",
      headerName: "Total break time",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "occupancy",
      headerName: "Occupancy",
      flex: 1,
      minWidth: 140,
      align: "center",
      headerAlign: "center",
    },
  ];

  useEffect(() => {
    if (agentPerformanceStatus === "pending") {
      setLocalLoading(true);
    } else {
      setLocalLoading(false);
      setDataRows([]);
    }
  }, [agentPerformanceStatus]);
  const handleReportTypeChange: any = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setDataRows([]);
    }, 500); // Small delay to simulate user interaction feedback
    setReportType(event.target.value as string);

    // Simulate download completion (due to CsvDownloader's lack of a completion callback)
  };

  const handleDateFromChange = (event: any) => {
    setDateFrom(event.target.value);
  };

  const handleDateToChange = (event: any) => {
    setDateTo(event.target.value);
  };

  const handleChange: any = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedAssignee(event.target.value as string);
  };

  useEffect(() => {
    const dropdownHeadings = document.querySelectorAll(".dropdown-heading");
    dropdownHeadings.forEach((heading: any) => {
      heading.style.height = "50px";
    });
  }, []);

  useEffect(() => {
    const transformedData = userData?.map((user) => ({
      id: user.id,
      username: user.username,
    }));
    if (Array.isArray(userData)) {
      setTheUser(transformedData);
    } else {
      setTheUser([]); // Fallback to an empty array if it's not an array
    }
  }, [userData]);

  const handleSubmit = () => {
    if (!dateFrom) {
      toast.error('Please select "From Date"');
      return;
    }
    if (!dateTo) {
      toast.error('Please select "To Date"');
      return;
    }
    if (!selectedAssignee) {
      toast.error("Please select Assignee");
      return;
    }

    const queryParams: any = {
      gte: dateFrom,
      lte: dateTo,
      call_type: reportType === "Inbound" ? "inbound" : "outbound",
    };

    if (selectedAssignee !== "All") {
      queryParams.user_id = selectedAssignee; // Add user_id when an assignee is selected
    }
    setParams(queryParams);
  };
  const formatDuration = (duration) => {
    const parts = duration.split(":").map((part) => part.padStart(2, "0"));
    return parts.join(":");
  };
  useEffect(() => {
    if (Array.isArray(agentPerformanceData)) {
      const transformedRows = agentPerformanceData.map(
        (item: any, index: number) => ({
          id: index + 1, // Unique identifier for the row
          srNo: index + 1,
          date: item.date || "-",
          agentName: item.agent_name || "-",
          totalLoginTime: item.total_login_time
            ? formatDuration(item.total_login_time)
            : "-",
          totalInboundCalls:
            reportType === "Inbound" ? item.total_calls || "-" : undefined,
          totalOutboundCalls:
            reportType === "Outbound" ? item.total_calls || "-" : undefined,
          totalTalkTime: item.total_talk_time
            ? formatDuration(item.total_talk_time)
            : "-",
          avgTalkTime: item.avg_talk_time
            ? formatDuration(item.avg_talk_time)
            : "-",
          totalHoldTime: item.total_hold_time
            ? formatDuration(item.total_hold_time)
            : "-",
          avgHoldTime: item.avg_hold_time
            ? formatDuration(item.avg_hold_time)
            : "-",
          // totalCallsHandled: "No data found",
          totalAcw: item.total_acw ? formatDuration(item.total_acw) : "-",
          avgAcw: item.avg_acw_time ? formatDuration(item.avg_acw_time) : "-",
          totalHandleTime: item.total_handle_time
            ? formatDuration(item.total_handle_time)
            : "-",
          avgHandleTime: item.avg_handle_time
            ? formatDuration(item.avg_handle_time)
            : "-",
          totalBreakTime: item.total_break_time
            ? formatDuration(item.total_break_time)
            : "-",

          totalManualTime: item.total_aux_inbound_time
            ? formatDuration(item.total_aux_inbound_time)
            : "-",
          totalInboundIdealTime: item.total_inbound_ideal_time
            ? formatDuration(item.total_inbound_ideal_time)
            : "-",
          totalOutboundIdealTime: item.total_outbound_ideal_time
            ? formatDuration(item.total_outbound_ideal_time)
            : "-",
          totaloutboundauxTime: item.total_outbound_time
            ? formatDuration(item.total_outbound_time)
            : "-",

          occupancy: item.occupancy || " ",
        })
      );

      setDataRows(transformedRows);
      setLocalLoading(false);
    } else {
      setDataRows([]); // Reset if data is not an array
      setLocalLoading(false);
    }

    setLocalLoading(false);
  }, [agentPerformanceData]);

  // const handleDownloadClick = () => {
  //   setLoading(true);

  //   // Simulate download completion (due to CsvDownloader's lack of a completion callback)
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 500); // Small delay to simulate user interaction feedback
  // };

  const downloaderRef = useRef(null);

  const handleDownloadClick = () => {
    if (downloaderRef.current) {
      downloaderRef.current.handleDownload();
    }
  };
  const resetFilters = () => {
    setDateFrom("");
    setDateTo("");
    setParams(null);
  };

  const ITEM_HEIGHT = 60;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150,
      },
    },
  };

  const handlePaginationChange = (newPaginationModel: any) => {
    setLocalLoading(true);
    setPaginationModel(newPaginationModel);
    setTimeout(() => {
      setLocalLoading(false);
    }, 1000);
  };

  return (
    <div id="kt_app_content_container" className="app-container mx-5">
      <div className="card card-flush">
        {/* Card Header */}
        <div
          className="card-header align-items-center py-1 gap-2 gap-md-5"
          style={{ justifyContent: "flex-start" }}
        >
          {/* Back button */}
          {/* <img
            src="https://insurance.circleonecrm.com/assets/arrow_back.svg"
            alt="Back"
            style={{ marginBottom: "-2px", cursor: "pointer" }}
            className="ng-star-inserted"
            onClick={() => {
              navigate("/reports/telephony/reports-list");
            }}
          /> */}
          <button
            className="btn btn-link mb-2"
            onClick={() => {
              navigate("/reports/telephony/reports-list");
            }}
            style={{ marginRight: "-17px" }}
          >
            <i
              className="bi bi-arrow-90deg-left"
              style={{
                fontSize: "20px",
                color: "black",
                cursor: "pointer",
              }}
            ></i>
          </button>
          <span className="fs-3 text-gray-800 fw-bold ms-3">
            {" "}
            Agent performance
          </span>
        </div>

        {/* Toolbar */}
        <div
          className="card-toolbar flex-row-fluid justify-content-start gap-5 d-flex mb-10"
          style={{ marginLeft: "30px" }}
        >
          <div className="w-100 mw-150px">
            <TextField
              id="date-from"
              label="From"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: {
                  max: new Date().toISOString().split("T")[0], // Restrict to today or earlier
                  style: { textTransform: "uppercase" }, // Optional: uppercase input text
                },
              }}
              fullWidth
              value={dateFrom}
              onChange={handleDateFromChange}
            />
          </div>
          <div className="w-100 mw-150px">
            <TextField
              id="date-to"
              label="To"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: {
                  max: new Date().toISOString().split("T")[0],
                  style: { textTransform: "uppercase" }, // Optional: uppercase input text
                },
              }}
              fullWidth
              value={dateTo}
              onChange={handleDateToChange}
            />
          </div>

          <div className="w-100 mw-150px">
            <FormControl fullWidth>
              <InputLabel id="select-type">Select Type</InputLabel>
              <Select
                labelId="select-type"
                id="select-type"
                label="Select Type"
                value={reportType}
                onChange={handleReportTypeChange}
              >
                <MenuItem value="Inbound">Inbound</MenuItem>
                <MenuItem value="Outbound">Outbound</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="w-100 mw-150px">
            <FormControl sx={{ width: "200px" }}>
              <InputLabel id="Assignee-select-label">Assignee</InputLabel>
              <Select
                labelId="Assignee-select-label"
                id="Assignee-select"
                label="Assignee"
                MenuProps={MenuProps}
                value={selectedAssignee}
                onChange={handleChange}
              >
                <MenuItem key="all" value="All">
                  All
                </MenuItem>
                {theUser?.map((assignee: any) => (
                  <MenuItem key={assignee.id} value={assignee.id}>
                    {assignee.username}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="ms-auto d-flex gap-3" style={{ marginRight: "20px" }}>
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>

            {/* CsvDownloader component outside the button */}
            <button className="btn btn-primary">
              <CsvDownloader
                ref={downloaderRef}
                filename={`${reportType}-performance-report`}
                datas={dataRows}
                columns={(reportType === "Inbound"
                  ? columnsInbound
                  : columnsOutbound
                ).map((col) => ({
                  id: col.field,
                  displayName: col.headerName,
                }))}
                separator=","
                wrapColumnChar={`"`}
              >
                Download
              </CsvDownloader>
            </button>

            <button className="btn btn-link" onClick={resetFilters}>
              <i className="bi bi-funnel fs-2 text-dark"></i>
            </button>
          </div>
        </div>

        <CardContent style={{ width: "100%" }}>
          {userLoading || agentPerformanceLoading || localLoading ? (
            <LoadingSpinner />
          ) : (
            <DataGrid
              rows={dataRows}
              columns={
                reportType === "Inbound" ? columnsInbound : columnsOutbound
              }
              pagination
              paginationModel={paginationModel}
              onPaginationModelChange={handlePaginationChange}
              loading={localLoading}
              disableColumnMenu
              pageSizeOptions={[5, 10, 15, 20]}
              sx={{
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "lightgray",
                  "&:last-child": {
                    justifyContent: "flex-end",
                  },
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                },
                "& .MuiDataGrid-columnsContainer": {
                  backgroundColor: "lightgray",
                },
                // Target the pagination select and actions by stable component classes
                "& .MuiTablePagination-select, .MuiTablePagination-actions": {
                  marginBottom: "10px",
                },
                // Target the DataGrid overlay wrapper with its stable class
                "& .MuiDataGrid-overlayWrapper": {
                  height: "50px",
                },
              }}
            />
          )}
        </CardContent>
      </div>
    </div>
  );
};

export default AgentPerformanceReport1;